/**
 * Functionality related to the search modal
 *
 * Click the "search" link on the tec.com website to see for yourself!
 *
 * @since feature/TECCOM-1783-new-search-experience
 */

( function() {
	const searchModalClass = 'tec-search-modal-background';
	const searchModalActiveClass = `${ searchModalClass }--active`;
	const tabClass = 'tec-search-modal__tab';
	const tabActiveClass = `${ tabClass }--active`;
	const resultsActiveClass = `tec-search-modal__searched-active`;

	// Recent searches
	const RECENT_SEARCHES_KEY = 'tec-recent-searches';
	const recentSearchesButtonClass = 'tec-search-modal__recent-search-button';
	// const keyNavActiveClass = 'tec-search-modal__key-nav-active';
	/* World not ready
	const keyboardNavKeys = [
		'ArrowDown',
		'ArrowUp',
		'Enter',
		'Escape',
	]; */

	// Endpoints
	const ENDPOINT_BLOG = 'https://theeventscalendar.com/wp-json/wp/v2/search';
	const ENDPOINT_KNOWLEDGEBASE = 'https://theeventscalendar.com/knowledgebase/wp-json/wp/v2/search';
	const ENDPOINT_DOCS = 'https://docs.theeventscalendar.com/wp-json/wp/v2/search';

	// Elements
	const searchToggle = document.querySelector( '.tec-search-trigger' );
	const searchToggleMobile = document.querySelector( '.tec-search-trigger-mobile' );
	const searchModal = document.querySelector( `.${ searchModalClass }` );
	const searchForm = document.querySelector( '.tec-search-modal-form' );
	const searchInput = document.querySelector( '.tec-search-modal-form__input' );
	const searchSearched = document.querySelector( '.tec-search-modal__searched' );
	const blankTerms = document.querySelectorAll( '.tec-search-modal__searching-item-term' );
	const closeButton = document.querySelector( '.tec-search-modal__legend-item--close' );

	const termButtonClass = 'tec-search-modal__searching-item';
	const termButtons = document.querySelectorAll( `.${ termButtonClass }` );

	const tabs = document.querySelectorAll( `.${ tabClass }` );

	// Icons
	const ICON_SEARCH = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.5 20L15.656 15.656" stroke="#0F1031" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" stroke="#0F1031" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

	/**
	 * Helper function to return search link on TEC.com website
	 *
	 * @param {String} term - Encoded search term
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const SECONDPAGE_BLOG = term => `https://theeventscalendar.com/page/2/?s=${ term }`;

	/**
	 * Helper function to return search link on knowledgebase website
	 *
	 * @param {String} term - Encoded search term
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const SECONDPAGE_KNOWLEDGEBASE = term => `https://theeventscalendar.com/knowledgebase/k/page/2/?s=${ term }`;

	/**
	 * Helper function to return search link on docs website
	 *
	 * @param {String} term - Encoded search term
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const SECONDPAGE_DOCS = term => `https://docs.theeventscalendar.com/page/2/?s=${ term }`;

	/**
	 * Helper function to determine if string is empty or not
	 *
	 * @param {String} term - The search term, possibly with spaces
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const isEmptyString = term => {
		if ( '' === term.split( ' ' ).join( '' ) ) {
			return true;
		}
		return false;
	};

	/**
	 * Retrieve search results from remote endpoint
	 *
	 * @param {String} term - The search term
	 * @param {String} endpoint - The WordPress REST API endpoint URL
	 * @param {String} page - Page to return (generally, 10 results per page)
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const getSearchResults = async( term, endpoint, page ) => {
		const url = `${ endpoint }?search=${ term }&page=${ page }`;
		const response = await fetch( url );
		const data = await response.json();
		const totalPages = response.headers.get( 'X-WP-TotalPages' );
		const total = response.headers.get( 'X-WP-Total' );

		return { data, totalPages, total };
	};

	/**
	 * Helper function to return the "second page URL"
	 * when there are greater than 10 results per tab
	 *
	 * @param {String} tab - knowledgebase, dev docs, etc.
	 * @param {String} term - The (unencoded) search term
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const getSecondPage = ( tab, term ) => {
		const encodedTerm = encodeURI( term );

		if ( 'knowledgebase' === tab ) {
			return SECONDPAGE_KNOWLEDGEBASE( encodedTerm );
		}

		if ( 'blog' === tab ) {
			return SECONDPAGE_BLOG( encodedTerm );
		}

		if ( 'docs' === tab ) {
			return SECONDPAGE_DOCS( encodedTerm );
		}
	};

	/**
	 * Helper function that returns parsed recent searches from localStorage
	 *
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const getRecentSearches = () => JSON.parse( localStorage.getItem( RECENT_SEARCHES_KEY ) );

	/**
	 * In the "notSearching" state, it shows recent searches.
	 * If no recent searches, it will show a "No Recent Searches" view.
	 *
	 * This function will show the proper view.
	 *
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const showRecentsOrNot = () => {
		// Do we have recent searches?
		const hasRecentSearches = Boolean( getRecentSearches() );

		if ( true === hasRecentSearches ) {
			// Yes, let's set state accordingly.
			searchModal.setAttribute( 'data-has-recents', 'true' );
		} else {
			// No, let's set state accordingly.
			searchModal.setAttribute( 'data-has-recents', 'false' );
		}
	};

	/**
	 * Function to set the "loading" state.
	 *
	 * In this state, the user will see a bunch of fake gray bars.
	 * That are generally considered to indicate loading.
	 *
	 * This state should not last for long.
	 *
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const setLoading = () => {
		searchModal.setAttribute( 'data-state', 'loading' );
	};

	/**
	 * Function to add a recent search term to localStorage
	 *
	 * @param {String} term - The search term to add
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const addToRecentSearches = term => {
		// Let's gather our "old" recent searches
		const oldRecentSearches = getRecentSearches();

		// We don't have any recent searches? Wow, get to searching, bud.
		if ( ! oldRecentSearches ) {
			// Lonely item :(
			const lonelyItemString = JSON.stringify( [ term ] );

			// Add the lonely item to localStorage
			localStorage.setItem( RECENT_SEARCHES_KEY, lonelyItemString );

			// Cease execution. Will fire again when a new term is added, no worries!
			return;
		}

		// Add the term to the TOP of the array, so not [ ...oldRecentSearches, term ]
		const newRecentSearches = [ term, ...oldRecentSearches ];

		// Remove duplicates with the built in Set object
		const noDuplicatesPlz = [ ...new Set( newRecentSearches ) ];

		// Slice off anything past the 10th item. Maybe even 10 is too many?
		const withAMaxOf10 = noDuplicatesPlz.slice( 0, 10 );

		// Set localStorage with the new and improved recent searches
		localStorage.setItem( RECENT_SEARCHES_KEY, JSON.stringify( withAMaxOf10 ) );
	};

	/**
	 * Function to set the "searched" state.
	 *
	 * This is when the user can see actual search results for their query.
	 *
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const setSearched = () => {
		searchModal.setAttribute( 'data-state', 'searched' );
	};

	/**
	 * Function to handle setting the active search results tab, in two parts:
	 *
	 * 1) Activate the "tab" element itself
	 * 2) Activate the div that houses all the results
	 *
	 * @param {String} tab - The tab (knowledgebase, dev docs, etc.)
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const setActiveTab = tab => {
		// 1) Handle the "tab" itself
		const oldActiveTab = document.querySelector( `.${ tabActiveClass }` );

		// If there is an "old" active tab, deactivate it
		if ( oldActiveTab ) {
			oldActiveTab.classList.remove( tabActiveClass );
		}

		// Select the new active tab
		const newActiveTab = document.querySelector( `.${ tabClass }[data-endpoint="${ tab }"]` );

		// Activate it
		newActiveTab.classList.add( tabActiveClass );

		// 2) Handle the results div
		const oldActiveResults = document.querySelector( `.${ resultsActiveClass }` );

		// Are there old active results? Deactivate them
		if ( oldActiveResults ) {
			oldActiveResults.classList.remove( resultsActiveClass );
		}

		// Select new results div
		const newActiveResults = searchSearched.querySelector( `[data-endpoint="${ tab }"]` );

		// Activate it
		newActiveResults.classList.add( resultsActiveClass );

		// We're now in the "searched" state
		setSearched();
	};

	/**
	 * Click handler for when some clicks a "start a new search" button
	 * Focuses searchInput, empties the value, and sets the "notSearching" state.
	 *
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const noResultsButtonHandler = () => {
		searchInput.focus();
		searchInput.value = '';
		// eslint-disable-next-line no-use-before-define
		setNotSearching();
	};

	/**
	 * Function to handle the population of search results HTML, in two parts
	 *
	 * 1) Display the search result links
	 * 2) Display the results count number within the tabs (knowledgebase, dev docs, etc.)
	 *
	 * @param {Object} results - The search results data (post title, URL)
	 * @param {Integer} total - The total number of results for the search
	 * @param {String} tab - The tab (knowledgebase, dev docs, etc.)
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const populateResults = ( results, totalString, tab, term ) => {
		// Just in case we have no results
		const noResultsClass = 'tec-search-modal__no-results';

		// Convert total to integer
		const total = parseInt( totalString );

		// 1) Search Results
		let html = '';

		if ( 0 === total ) {
			html += `<div class="${ noResultsClass }">No results found. Would you like to <button>start a new search</button>?</div>`;
		} else {
			// Store the results in the html variable
			results.forEach( ( { title, url } ) => {
				html += `<div><a href="${ url }">${ title }</a></div>`;
			} );

			// Got more than 10 results? Get the "second page" link and send them off to another site
			if ( total > 10 ) {
				const secondPage = getSecondPage( tab, term );
				html += `<div><a class="tec-search-modal__second-page-link" href="${ secondPage }">Next Page</a></div>`;
			}
		}

		// Which tab are we populating?
		const resultsEl = searchSearched.querySelector( `[data-endpoint="${ tab }"]` );

		// Populate the tab with results
		resultsEl.innerHTML = html;

		// Add event listener to "start new search" button if no results returned
		if ( 0 === total ) {
			const noResultsButton = document.querySelector( `.tec-search-modal__searched > [data-endpoint="${ tab }"] .${ noResultsClass } > button` );
			noResultsButton.addEventListener( 'click', noResultsButtonHandler );
		}

		// 2) Tab count
		const countElement = document.querySelector( `.tec-search-modal__tab[data-endpoint="${ tab }"] .tec-search-modal__tab-count` );
		countElement.innerText = total;
	};

	/**
	 * Function used to determine active tab on form submissions and recent search button clicks
	 * Just those two events *because* they are not explicitly searching on a particular tab
	 *
	 * @param {String} kbTotal - Knowledgebase result count
	 * @param {String} docsTotal - DevDocs result count
	 * @param {String} blogTotal - TEC.com result count
	 *
	 * @since release/M22.rosemary
	 */
	const tabPrioritizer = ( kbTotal, docsTotal, blogTotal ) => {
		// We have knowledgebase results, let's prioritize that and cease execution
		if ( parseInt( kbTotal ) > 0 ) {
			return 'knowledgebase';
		}

		// Do we have TEC.com content? Let's return that and cease execution
		if ( parseInt( blogTotal ) > 0 ) {
			return 'blog';
		}

		// Do we have dev docs content? Okay, let's return that.
		if ( parseInt( docsTotal ) > 0 ) {
			return 'docs';
		}

		// At this point, we have 0 results across all tabs
		// I guess we can return 'knowledgebase' again
		return 'knowledgebase';
	};

	/**
	 * Function that gathers search results and sets active tab accordingly.
	 *
	 * @param {String} term - The search term
	 * @param {String} tab - The active tab
	 *
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const startSearching = ( term, tab = false ) => {
		// If the term is an empty string, don't do anything
		if ( isEmptyString( term ) ) {
			return;
		}

		// I guess we're searching now. Set loading state.
		setLoading();

		// Might as well add the term to recent searches
		addToRecentSearches( term );

		// Get ready to show recent searches should we return to that state later
		showRecentsOrNot();

		// Always page 1, for now
		const page = 1;

		// Retrieve blog results
		const blogResults = getSearchResults( term, ENDPOINT_BLOG, page );

		// Retrive knowledgebase results
		const kbResults = getSearchResults( term, ENDPOINT_KNOWLEDGEBASE, page );

		const docsResults = getSearchResults( term, ENDPOINT_DOCS, page );

		// Promise we get back results of all endpoints
		Promise.all( [ blogResults, kbResults, docsResults ] ).then( ( [ blog, kb, docs ] ) => {
			// Populate results of knowledgebase tab
			populateResults( kb.data, kb.total, 'knowledgebase', term );

			// Populate results of docs tab
			populateResults( docs.data, docs.total, 'docs', term );

			// Populate results of everything else tab (formerly known as "blog")
			populateResults( blog.data, blog.total, 'blog', term );

			let activeTab;

			if ( false === tab ) {
				activeTab = tabPrioritizer( kb.total, docs.total, blog.total );
			} else {
				activeTab = tab;
			}

			// Set the active tab
			setActiveTab( activeTab );
		} );
	};

	/**
	 * Function to handle when a "recent search item" button is clicked.
	 * These buttons appear in the "not searching" state. For example:
	 *
	 * [Magnifying Glass Icon] Most recently searched term
	 * [Magnifying Glass Icon] Second most recently searched term
	 *
	 * @param {Object} target - Destructured from the event
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const recentSearchButtonHandler = ( { target } ) => {
		// Get the innerText property from the button, rename to "term"
		const { innerText: term } = target.closest( 'button' );

		// Let's update the searchInput value as if they actually typed it in.
		searchInput.value = term;

		// Start searching
		startSearching( term );
	};

	/**
	 * Function to populate recent searches.
	 *
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const populateRecentSearches = () => {
		// Get recent searches
		const recentSearches = getRecentSearches();

		// We don't have recent searches, let's chill
		if ( ! recentSearches ) {
			return;
		}

		// We do have recent searches, let's start writing HTML
		let html = '';

		// Build the HTML
		recentSearches.forEach( search => {
			// "Escape" the HTML
			// @link: https://stackoverflow.com/a/22706073
			const escapeStaging = document.createElement( 'p' );
			escapeStaging.appendChild( document.createTextNode( search ) );
			const { innerHTML: escapedSearch } = escapeStaging;
			escapeStaging.remove();

			// Build the HTML
			html += `<div><button class="${ recentSearchesButtonClass }"><span>${ ICON_SEARCH }</span><span>${ escapedSearch }</span></div>`;
		} );

		// Select the HTML element we're going to fill up with new HTML
		const recentsEl = document.querySelector( '.tec-search-modal__fresh-recents-searches' );

		// Fill up with new HTML
		recentsEl.innerHTML = html;

		// Select all newly-created recent search buttons
		const recentSearchButtons = recentsEl.querySelectorAll( `.${ recentSearchesButtonClass }` );

		// Add event listeners to each button
		recentSearchButtons.forEach( button => button.addEventListener( 'click', recentSearchButtonHandler ) );
	};

	/**
	 * Set the "notSearching" state.
	 * This is when either recent searches show up.
	 * Or, if no recent searches, a "No Recent Searches" view.
	 *
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const setNotSearching = () => {
		// Make sure recent searches are up-to-date
		populateRecentSearches();

		// Set the state
		searchModal.setAttribute( 'data-state', 'notSearching' );
	};

	/**
	 * Function to handle when a "term button" is clicked.
	 * These buttons appear in the "searching" state. For example:
	 *
	 * "Test in Knowledgebase"
	 * "Test in Developer Docs"
	 * "Test in Blog Posts"
	 *
	 * @param {Object} target - Destructured from the event
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const termButtonClickHandler = ( { target } ) => {
		// Destructure the data-endpoint value from the "searching" state  buttons
		const { endpoint } = target.closest( '.tec-search-modal__searching-item' ).dataset;

		// We're ready to start searching!
		startSearching( searchInput.value, endpoint );
	};

	/**
	 * Helper function to enable/disable body overflow when modal is open/closed.
	 *
	 * @param {String} hiddenOrNot - 'hidden' if you want to hide, default to setting overflow to auto
	 * @since feature/TECCOM-1783-new-search-experience
	*/
	const bodyOverflow = ( hiddenOrNot ) => {
		if ( 'hidden' === hiddenOrNot ) {
			document.body.style.overflow = 'hidden';
			document.body.style.userSelect = 'none';
		} else {
			document.body.style.overflow = 'auto';
			document.body.style.userSelect = 'auto';
		}
	};

	/**
	 * Function that deactivates the modal.
	 *
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const deactivateModal = () => {
		// Allow user to scroll again
		bodyOverflow();

		// STOP listening for ArrowDown, ArrowUp, etc.
		/* World not ready */
		// window.removeEventListener( 'keyup', searchModalKeyHandler );

		// Hide the search modal
		searchModal.classList.remove( searchModalActiveClass );
	};

	/**
	 * Function that handles click on the search modal.
	 * Basically, just a way of closing the modal.
	 *
	 * @param {Object} target - Destructured from event
	 *
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const searchModalClickHandler = ( { target } ) => {
		const isDirectHit = target.classList.contains( searchModalActiveClass );

		// Make sure we're clicking on *just* the background, and not inner elements
		if ( ! isDirectHit ) {
			return;
		}

		deactivateModal();
	};

	/**
	 * Function to set the "searching" state.
	 *
	 * This is before a search has actually taken place.
	 *
	 * As the user types, the user will see buttons like the following:
	 *
	 * "Test in Knowledgebase"
	 * "Test in Developer Docs"
	 * "Test in Blog Posts"
	 *
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const setSearching = () => {
		searchModal.setAttribute( 'data-state', 'searching' );
	};

	/**
	 * This happens in the "searching" state.
	 *
	 * This is what takes the searchInput value and plops that into the each term button.
	 *
	 * For example:
	 *
	 * "Test in Knowledgebase"
	 * "Test in Developer Docs"
	 * "Test in Blog Posts"
	 *
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const teleportTermToDivs = () => {
		blankTerms.forEach( term => {
			term.innerText = searchInput.value;
		} );
	};

	/**
	 * Function to handle searchInput keyup events.
	 *
	 * @param {String} oldValue - This is the value *before* the keyup event occurs.
	 * @param {String} key - This is the key (like "ArrowDown") that was pressed.
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	const searchInputKeyHandler = ( oldValue ) => {
		// Let's not mess with the keyboard nav?
		// World not ready
		// When world is ready, change params to ( oldValue, key )
		/*const hasKey = keyboardNavKeys.includes( key );

		if ( hasKey ) {
			return;
		}*/

		// The string hasn't changed, stop running
		if ( oldValue === searchInput.value ) {
			return;
		}

		// If the search input is empty, we're not searching anymore. Sorry.
		if ( isEmptyString( searchInput.value ) ) {
			setNotSearching();
			return;
		}

		// Set searching state
		setSearching();

		// Make sure "term buttons" have been teleported accordingly
		teleportTermToDivs();
	};

	/**
	 * Function to check which item the keyboard nav is highlighting
	 *
	 * @param {Object} nodes - A NodeList of all selected nodes (recent search buttons, term buttons, search result links.)
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	// World Not Ready
	/*
	const getActiveIndex = nodes => {
		let activeIndex = false;

		nodes.forEach( ( node, index ) => {
			if ( node.classList.contains( keyNavActiveClass ) ) {
				activeIndex = index;
			}
		} );

		return activeIndex;
	};*/

	/**
	 * Function to related to keyboard navigation of buttons/links in the search modal.
	 *
	 * Broken down into three parts:
	 *
	 * #1) Handle the ArrowDown key
	 * #2) Handle the ArrowUp key
	 * #3) Handle the Enter key
	 *
	 * @param {Object} buttons - A NodeList of all selected nodes (recent search buttons, term buttons, search result links.)
	 * @param {String} key - ArrowDown, ArrowUp, Enter
	 * @since feature/TECCOM-1783-new-search-experience
	 */

	// World Not Ready
	/*
	const handleKeyNav = ( buttons, key ) => {
		const lastIndex = buttons.length - 1;
		const activeIndex = getActiveIndex( buttons );

		// #1: Handle the ArrowDown key
		if ( 'ArrowDown' === key ) {
			if ( false === activeIndex ) {
				// First item gets activated
				buttons[ 0 ].classList.add( keyNavActiveClass );

				// Let's cease execution and wait for a new keyup event!
				return;
			}

			// We can't have two active buttons at once!
			buttons[ activeIndex ].classList.remove( keyNavActiveClass );

			// Let's handle lastIndex before normal increments
			if ( activeIndex === lastIndex ) {
				buttons[ 0 ].classList.add( keyNavActiveClass );

				return;
			}

			// Normal increment (i.e. 1 to 2, out of 2 or greater)
			buttons[ activeIndex + 1 ].classList.add( keyNavActiveClass );
		}

		// #2: Handle the ArrowUp key
		if ( 'ArrowUp' === key ) {
			if ( false === activeIndex ) {
				// Last item gets activated
				buttons[ lastIndex ].classList.add( keyNavActiveClass );

				return;
			}

			// We can't have two active buttons at once!
			buttons[ activeIndex ].classList.remove( keyNavActiveClass );

			// Let's handle first index before normal decrements
			if ( activeIndex === 0 ) {
				buttons[ lastIndex ].classList.add( keyNavActiveClass );

				return;
			}

			// Normal decrement (i.e. 2 to 1, out of 2 or greater)
			buttons[ activeIndex - 1 ].classList.add( keyNavActiveClass );
		}

		// #3: Handle the Enter/Return key
		if ( 'Enter' === key ) {
			// Simulate a click on the active button
			buttons[ activeIndex ].click();
		}
	};*/

	/**
	 * Function to handle keyboard navigation when the search modal is open.
	 *
	 * @param {Object} target - Destructured from event
	 * @param {String} key - Destructured from event: Escape, ArrowDown, ArrowUp, Enter
	 * @since feature/TECCOM-1783-new-search-experience
	 */
	/* World Not Ready
	const searchModalKeyHandler = ( { target, key } ) => {
		const hasKey = keyboardNavKeys.includes( key );

		// If Escape, ArrowDown, ArrowUp, or Enter has not been pressed...STOP
		if ( ! hasKey ) {
			return;
		}

		// If Escape key is pressed, deactivate the modal
		if ( 'Escape' === key ) {
			deactivateModal();
		}

		// If "Enter" key is pressed while searchInput is targeted, do NOTHING
		if ( searchInput === target && 'Enter' === key ) {
			return;
		}

		// Destructure the state, and whether or not we have recent searches active
		const { state, hasRecents } = searchModal.dataset;

		// These are the only states that keyboard nav worsk
		const keyNavStates = [
			'notSearching',
			'searching',
			'searched',
		];

		// Are we in a key nav state? True or false.
		const inKeyNavState = keyNavStates.includes( state );

		// ArrowUp/ArrowDown/Enter do nothing in the current state, let's cease execution
		if ( ! inKeyNavState ) {
			return;
		}

		// We're not searching, but we have no recents
		if ( 'notSearching' === state && 'true' !== hasRecents ) {
			return;
		}

		// Someone is trying to navigate to buttons/links, let's unfocus the search input
		searchInput.blur();

		// State #1, notSearching with Recent Searches
		if ( 'notSearching' === state && 'true' === hasRecents ) {
			const recentSearchButtons = document.querySelectorAll( `.${ recentSearchesButtonClass }` );

			handleKeyNav( recentSearchButtons, key );
		}

		// State #2, Searching
		if ( 'searching' === state ) {
			handleKeyNav( termButtons, key );
		}

		// State #3, Search Results showing (todo: what if there are 0 results??)
		if ( 'searched' === state ) {
			const searchedLinks = document.querySelectorAll( `.tec-search-modal__searched-active a` );

			handleKeyNav( searchedLinks, key );
		}
	}; */

	/**
	 * Helper function to activate the search modal.
	 *
	 * @since feature/TECCOM-1783-new-search-experience
	*/
	const activateModal = event => {
		event.preventDefault();

		// Overflow hidden
		bodyOverflow( 'hidden' );

		// Let's make sure we grab recent searches
		populateRecentSearches();

		// Do we have recent searches? Let's make sure they show up as expected
		showRecentsOrNot();

		// Reveal the modal
		searchModal.classList.add( searchModalActiveClass );

		// Prepare to be dismissed
		searchModal.addEventListener( 'click', searchModalClickHandler );

		// Stateless? I guess we're notSearching
		if ( ! searchModal.dataset.state ) {
			searchModal.setAttribute( 'data-state', 'notSearching' );
		}

		// Focus on the search input
		searchInput.focus();

		// Listen for keystrokes on search input
		let oldValue = '';
		searchInput.addEventListener( 'keydown', function() {
			oldValue = searchInput.value;
		} );

		searchInput.addEventListener( 'keyup', function( { key } ) {
			searchInputKeyHandler( oldValue, key );
		} );

		// Add keyup event listener on the entire window (up, down, enter, escape)
		// window.addEventListener( 'keyup', searchModalKeyHandler );
		// Going to save this for Phase 2
	};

	/**
	 * While in the "searched" state, this function handles click events on the tabs.
	 *
	 * For example: Knowledgebase, Developer Docs, etc.
	 *
	 * @since feature/TECCOM-1783-new-search-experience
	*/
	const tabClickHandler = ( { target } ) => {

		console.log('tab clicked!');
		// Bubble up to the button, if needed
		const clickedTab = target.closest( 'button' );

		// Do nothing if tab is already active
		if ( clickedTab.classList.contains( tabActiveClass ) ) {
			return;
		}

		// Destructure the data-endpoint value
		const { dataset: { endpoint } } = clickedTab;

		// Set the tab according to the endpoint (knowledgebase, tec.com, etc.)
		setActiveTab( endpoint );
	};

	/**
	 * Function to handle search form submission events.
	 *
	 * @since feature/TECCOM-1783-new-search-experience
	*/
	const formHandler = ( event ) => {
		// Hijack default browser behavior because this isn't a normal HTML form
		event.preventDefault();

		// Start searching
		startSearching( searchInput.value );
	};

	if ( searchToggle ) {
		searchToggle.addEventListener( 'click', activateModal );
	}

	if ( searchToggleMobile ) {
		searchToggleMobile.addEventListener( 'click', activateModal );
	}

	if ( closeButton ) {
		closeButton.addEventListener( 'click', deactivateModal );
	}

	if ( searchForm ) {
		searchForm.addEventListener( 'submit', formHandler );
	}

	termButtons.forEach( button => {
		if ( button ) {
			button.addEventListener( 'click', termButtonClickHandler );
		}
	} );

	tabs.forEach( tab => {
		if ( tab ) {
			tab.addEventListener( 'click', tabClickHandler );
		}
	} );
} )();
